var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-condition"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"slot"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }